/** Visible "*" for a required field; the input itself carries `aria-required`. */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-destructive">
      {' *'}
    </span>
  )
}
